// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-accManage{
    width: 100%;
    height: 100%;
    position: relative;
    /* background-color: rgb(1, 17, 31); */
    background-color:#fff ;
    display: block;
    justify-content: center;
    align-items: center;
}

.head-accManage{
    position: relative;
    display: block;
    width: 100%;
    height: 9%;
/* background-color: rgba(195,195,195,1); */
/* border-bottom: 1px solid rgba(195,195,195,1); */
}
.title-accManage{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.txt-title-accManage{
    /* color: rgba(195,195,195,1); */
    color: #003757;
    font-size: xx-large;
}
.menu-accManage{
    position: relative;
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    height: 50%;
}
.head-line{
width: 90%;
position: absolute;
left: 5%;
top:85%;
/* color:rgba(195,195,195,1); */
color: 003757;
}
.compact-menu-list{
    position: relative;
    display: flex;
    width: 40%;
    height: 100%;
    left: 5%;
    justify-content: center;
    align-items: center;
    justify-content: space-between; /* Distribuye el espacio entre los elementos */
  list-style-type: none; /* Elimina los estilos de viñetas de la lista */
  padding: 0; /* Elimina el relleno predeterminado de la lista */
  margin: 0; 
}
.compact-menu-list li {
    /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */
    width: 25%;
    height: 50%;
    background-color: transparent;
    border-right: 1px solid #a1a1a150;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: medium;
    cursor: pointer;
    /* color: rgba(195,195,195,1); */
    color: #003757;
  }
  .compact-menu-list li:hover{
    background-color: rgba(130, 134, 138, 0.452);
  }
.list-selected{
    /* background-color: rgba(195,195,195,1) !important; */
    background-color: #003757 !important;
    /* color: rgb(1, 17, 31) !important; */
    color:aliceblue !important;
}
.cont-accManage{
    position: relative;
    display: block;
    width: 100%;
    height: 90%;
/* background-color: rgb(95, 95, 95); */
 
}`, "",{"version":3,"sources":["webpack://./src/sections/styles/acciones.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,sBAAsB;IACtB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,UAAU;AACd,2CAA2C;AAC3C,kDAAkD;AAClD;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gCAAgC;IAChC,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;AACA,UAAU;AACV,kBAAkB;AAClB,QAAQ;AACR,OAAO;AACP,+BAA+B;AAC/B,aAAa;AACb;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B,EAAE,8CAA8C;EAChF,qBAAqB,EAAE,+CAA+C;EACtE,UAAU,EAAE,kDAAkD;EAC9D,SAAS;AACX;AACA;IACI,yEAAyE;IACzE,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,4CAA4C;EAC9C;AACF;IACI,sDAAsD;IACtD,oCAAoC;IACpC,sCAAsC;IACtC,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf,uCAAuC;;AAEvC","sourcesContent":[".main-accManage{\r\n    width: 100%;\r\n    height: 100%;\r\n    position: relative;\r\n    /* background-color: rgb(1, 17, 31); */\r\n    background-color:#fff ;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.head-accManage{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 9%;\r\n/* background-color: rgba(195,195,195,1); */\r\n/* border-bottom: 1px solid rgba(195,195,195,1); */\r\n}\r\n.title-accManage{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.txt-title-accManage{\r\n    /* color: rgba(195,195,195,1); */\r\n    color: #003757;\r\n    font-size: xx-large;\r\n}\r\n.menu-accManage{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: left;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.head-line{\r\nwidth: 90%;\r\nposition: absolute;\r\nleft: 5%;\r\ntop:85%;\r\n/* color:rgba(195,195,195,1); */\r\ncolor: 003757;\r\n}\r\n.compact-menu-list{\r\n    position: relative;\r\n    display: flex;\r\n    width: 40%;\r\n    height: 100%;\r\n    left: 5%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    justify-content: space-between; /* Distribuye el espacio entre los elementos */\r\n  list-style-type: none; /* Elimina los estilos de viñetas de la lista */\r\n  padding: 0; /* Elimina el relleno predeterminado de la lista */\r\n  margin: 0; \r\n}\r\n.compact-menu-list li {\r\n    /* flex-grow: 1; Permite que los elementos ocupen el espacio disponible */\r\n    width: 25%;\r\n    height: 50%;\r\n    background-color: transparent;\r\n    border-right: 1px solid #a1a1a150;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: medium;\r\n    cursor: pointer;\r\n    /* color: rgba(195,195,195,1); */\r\n    color: #003757;\r\n  }\r\n  .compact-menu-list li:hover{\r\n    background-color: rgba(130, 134, 138, 0.452);\r\n  }\r\n.list-selected{\r\n    /* background-color: rgba(195,195,195,1) !important; */\r\n    background-color: #003757 !important;\r\n    /* color: rgb(1, 17, 31) !important; */\r\n    color:aliceblue !important;\r\n}\r\n.cont-accManage{\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 90%;\r\n/* background-color: rgb(95, 95, 95); */\r\n \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
